import { ShopifyClient, getGraphQlCollectionId } from '../helpers';
import axios from 'axios';

export const FETCH_COLLECTION_REQUEST = 'FETCH_COLLECTION_REQUEST';
export const FETCH_COLLECTION_SUCCESS = 'FETCH_COLLECTION_SUCCESS';
export const FETCH_COLLECTION_FAILURE = 'FETCH_COLLECTION_FAILURE';

export const fetchCollectionRequest = () => {
  return{
    type: FETCH_COLLECTION_REQUEST
  };
};

export const fetchCollectionSuccess = collection => {
  return {
    type: FETCH_COLLECTION_SUCCESS,
    collection
  };
};
export const fetchCollectionFailure = error => {
  return {
    type: FETCH_COLLECTION_FAILURE,
    error
  };
};

export const fetchCollection = id => {
  return dispatch => {
    dispatch(fetchCollectionRequest());

    const collectionId = getGraphQlCollectionId(id);

    ShopifyClient.collection.fetchWithProducts(collectionId, {productsFirst: 10}).then((collection) => {
      return dispatch(fetchCollectionSuccess(collection))
    });
  };
};
